import React, {useState} from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import DriverRow from "./DriverRow";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getDriversData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import NewDriver from "./NewDriver";
import axios from "axios";
import {createSetDataFreshAction, createSetDriversDataAction} from "../../../actions/dataActions";
import {useDriversData} from "../../../hooks/useDriversData";
import {ToastContainer, toast} from "react-toastify";


export default function DriverView(props){
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    let loaded = useDriversData({page}, dataFresh);
    let data = useSelector(getDriversData);


    const onSave = (item) => {
        let url = item.id ? props.endpoint+"drivers/"+item.id : props.endpoint+"drivers";
        const conf = {
            url: url,
            method: item.id ? "put": "post",
            data:item
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving this driver", {position: "top-right"});
        })
    }
    const onDelete = item => {
        const conf = {
            url: props.endpoint+"drivers/"+item.id,
            method: "delete"
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error deleting this driver", {position: "top-right"});
        })
    }
    const onChange = (e,index) => {
        let newResults = [...data.results];
        let newDrivers = {...data, results: newResults};
        let newDriver = {...data.results[index]}
        newDriver[e.target.name] = e.target.value;
        newDrivers.results[index] = newDriver
        dispatch(createSetDriversDataAction(newDrivers));
    }

    if(!loaded){
        return (<LoadingSpinner />);
    }

    return (
        <div>
            <br/>
            <NewDriver onSave={onSave}/>
            <Box>
                <details>
                    <summary><Title>Driver</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((driver, index) => (
                                    <DriverRow
                                        driver={driver}
                                        handleSave={onSave}
                                        index={index}
                                        handleChange={onChange}
                                        onDelete={onDelete}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                </details>
            </Box>
        </div>
    );

}